import { render, staticRenderFns } from "./LinkQuestion.vue?vue&type=template&id=321017da&"
import script from "./LinkQuestion.vue?vue&type=script&lang=js&"
export * from "./LinkQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports